import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { environment } from "../../../environments/environment";
import { CaqRequestService } from "../caq-request/caq-request.service";
import { EstatisticasCaqDto } from "../../dtos/estatisticas-caq-dto";

@Injectable({ providedIn: 'root' })
export class EstatisticasCaqService {
    private apiUrl = `${environment.apiUrl}/financiamento-entes-federados`;

    constructor(
        private caqRequestService: CaqRequestService
    ) { }

    buscarEstatisticasNacional(pqr: any): Promise<EstatisticasCaqDto> {
        return firstValueFrom(
            this.caqRequestService.post<EstatisticasCaqDto>(`${this.apiUrl}/nacional/estatisticas`, pqr)
        );
    }

    buscarEstatisticasPlanoEstado(codUf: number | string, pqr: any): Promise<EstatisticasCaqDto> {
        return firstValueFrom(
            this.caqRequestService.post<EstatisticasCaqDto>(`${this.apiUrl}/plano/estado/${codUf}/estatisticas`, pqr)
        );
    }
}
